import { render, staticRenderFns } from "./ProjectBasicDetails.vue?vue&type=template&id=b10d0512&scoped=true"
import script from "./ProjectBasicDetails.vue?vue&type=script&lang=js"
export * from "./ProjectBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./ProjectBasicDetails.vue?vue&type=style&index=0&id=b10d0512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10d0512",
  null
  
)

export default component.exports